import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";

import { Dimmer } from "../components/spinner";
const CatalogoCuentasPresuGastos = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const txtBuscador = useRef();

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [valor, setValor] = useState(0.0);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CUENTA", textAlign: "center" },
    { label: "AUXILIAR", textAlign: "center" },
    { label: "DESCRIPCIÓN", textAlign: "left" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.cuenta.includes(target.value) ||
              x.auxiliar.toLowerCase().includes(target.value.toLowerCase()) ||
              x.descripcionaux
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarRegistros = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/catalogocuentasgastos?idefiscal=${idefiscal}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          var datos = [];
          for (let i = 0; i < response.data.length; i++) {
            datos.push({
              idcuenta: response.data[i].idcuenta,
              cuenta: response.data[i].cuenta,
              auxiliar: response.data[i].auxiliar,
              descripcion: response.data[i].descripcion,
              disponible: response.data[i].disponibilidad,
              idcat: response.data[i].idcategoriaprogramatica,
              idpuc: response.data[i].idpuc,
              descripcionaux: response.data[i].descripcionaux,
              aumentado: response.data[i].aumentado,
              disminuido: response.data[i].disminuido,
              precomprometido: response.data[i].precomprometido,
              montoinicial: response.data[i].montoinicial,
              comprometido: response.data[i].comprometido,
            });
          }
          setRecords(datos);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const seleccionarPrecompromiso = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/presupuesto/precompromiso?id=${id}`;
    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.compro > 0) {
            setValor(response.data.compro);
          } else {
            setValor(0.0);
          }

          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };

  const seleccionarClassPresupuestaria = () => {
    blanquear();
    props.onHideAceptaClasPresupuestaria(
      values.cuenta,
      values.descripcion,
      values.auxiliar,
      values.disponible,
      values.idcuenta,
      values.idcat,
      values.idpuc,
      values.descripcionaux,
      values.montoinicial,
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setActivo(false);
    setItemSelect(index);
    let id = recordsAfterPagingAndSorting()[index].idcuenta;
    let aumento = 0.0;
    let dismunu = 0.0;
    let comprom = 0.0;
    let precomp = 0.0;
    let inicial = 0.0;
    let total = 0.0;

    inicial = recordsAfterPagingAndSorting()[index].montoinicial;
    aumento = recordsAfterPagingAndSorting()[index].aumentado;
    dismunu = recordsAfterPagingAndSorting()[index].disminuido;
    comprom = recordsAfterPagingAndSorting()[index].comprometido;
    precomp = recordsAfterPagingAndSorting()[index].precomprometido;

    total =
      parseFloat(inicial) +
      parseFloat(aumento) -
      parseFloat(dismunu) -
      parseFloat(comprom) -
      parseFloat(precomp) -
      parseFloat(valor);

    seleccionarPrecompromiso(id);
    setValues({
      cuenta: recordsAfterPagingAndSorting()[index].cuenta,
      descripcion: recordsAfterPagingAndSorting()[index].descripcion,
      auxiliar: recordsAfterPagingAndSorting()[index].auxiliar,
      montoinicial: recordsAfterPagingAndSorting()[index].montoinicial,
      disponible: total,
      idcuenta: recordsAfterPagingAndSorting()[index].idcuenta,
      idcat: recordsAfterPagingAndSorting()[index].idcat,
      idpuc: recordsAfterPagingAndSorting()[index].idpuc,
      descripcionaux: recordsAfterPagingAndSorting()[index].descripcionaux,
    });
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarRegistros();
        txtBuscador.current?.focus();
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>Cuentas Presupuestarias</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12 m-0">
          <div className="input-group input-group-sm mb-3 m-0 col-md-5">
            <input
              type="text"
              ref={txtBuscador}
              onChange={handleSearch}
              className="form-control rounded-pill search-input"
              placeholder="Buscar Cuenta Presupuestaria..."
              style={{
                fontSize: "12px",
                textTransform: "uppercase",
              }}
            />
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      className="py-2 text-center"
                      style={{ width: "150px", fontSize: "14px" }}
                    >
                      {item.cuenta}
                    </td>
                    <td
                      className="py-2 text-center"
                      style={{ width: "50px", fontSize: "14px" }}
                    >
                      {item.auxiliar}
                    </td>
                    <td
                      className="py-2 text-left"
                      style={{ width: "auto", fontSize: "14px" }}
                    >
                      {item.auxiliar === '0000' ? item.descripcion : item.descripcionaux}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={seleccionarClassPresupuestaria}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoCuentasPresuGastos;
